import { FC } from 'react';
import { useUserRegistrationHooks } from 'hooks/u002/useUserRegistrationHooks';
import { PrivacyNoticeConsent } from './PrivacyNoticeConsent';
import { TermOfServiceConsent } from './TermOfServiceConsent';
import { Top } from './Top';
import { UserRegistration } from './UserRegistration';
import { GetAuditionResponse } from 'hooks/u002/useGetAuditionHooks';
import { TemporaryRegistration } from './TemporaryRegistration';
import { useSearchParams } from 'react-router-dom';
import { PhoneVerification } from './PhoneVerification';
import { AgeVerification } from './AgeVerification';
import { UnderThirteenGuidance } from './UnderThirteenGuidance';
import { UnderEighteenGuidance } from './UnderEighteenGuidance';
import { UnauthSpecificUseConsent } from './UnauthSpecificUseConsent';
import { UnauthAuditionTermsConsent } from './UnauthAuditionTermsConsent';
import { UnauthPrivacyPolicyConsent } from './UnauthPrivacyPolicyConsent';
import { GroupRegistration } from './GroupRegistration';

type Audition = GetAuditionResponse & {
  audition_id: string;
};
type AuditionUserRegistration = {
  audition: Audition;
};
export const AuditionUserRegistration: FC<AuditionUserRegistration> = (props) => {
  const { ...state } = useUserRegistrationHooks(props.audition.now_dtm);
  const [searchParam] = useSearchParams();
  const sessionId = searchParam.get('sessionId');
  const authState = searchParam.get('status');
  if (state == null) {
    return <></>;
  }
  if (state.page === 'TemporaryRegistration') {
    if (authState === 'approved') {
      const { ...pageProps } = state;
      return <TemporaryRegistration {...pageProps} />;
    }
  }
  if (sessionId) {
    if (state.page === 'PhoneVerification') {
      const { ...pageProps } = state;
      return <PhoneVerification {...pageProps} />;
    }
  }
  if (state.page === 'Top') {
    const { ...pageProps } = state;
    return <Top {...pageProps} title={props.audition.title} />;
  }
  if (state.page === 'AgeVerification') {
    const { ...pageProps } = state;
    return <AgeVerification {...pageProps} />;
  }
  if (state.page === 'UnderEighteenGuidance') {
    const { ...pageProps } = state;
    return <UnderEighteenGuidance {...pageProps} auditionId={props.audition.audition_id} />;
  }
  if (state.page === 'UnderThirteenGuidance') {
    const { ...pageProps } = state;
    return <UnderThirteenGuidance {...pageProps} />;
  }
  if (state.page === 'TermOfServiceConsent') {
    const { ...pageProps } = state;
    return <TermOfServiceConsent {...pageProps} audition={props.audition} />;
  }
  if (state.page === 'PrivacyNoticeConsent') {
    const { ...pageProps } = state;
    return <PrivacyNoticeConsent {...pageProps} audition={props.audition} />;
  }
  if (state.page === 'SpecificUseConsent') {
    const { ...pageProps } = state;
    return <UnauthSpecificUseConsent {...pageProps} audition={props.audition} />;
  }
  if (state.page === 'PrivacyPolicyConsent') {
    const { ...pageProps } = state;
    return <UnauthPrivacyPolicyConsent {...pageProps} audition={props.audition} />;
  }
  if (state.page === 'AuditionTermsConsent') {
    const { ...pageProps } = state;
    return <UnauthAuditionTermsConsent {...pageProps} audition={props.audition} />;
  }
  if (state.page === 'GroupRegistration') {
    const { ...pageProps } = state;
    return <GroupRegistration {...pageProps} audition={props.audition} />;
  }
  if (state.page === 'TemporaryRegistration') {
    const { ...pageProps } = state;
    return <TemporaryRegistration {...pageProps} />;
  }
  if (state.page === 'UserRegistration') {
    const { ...pageProps } = state;
    return <UserRegistration {...pageProps} />;
  }
  return <></>;
};
